interface IndexSectionHeaderProps {
  /** The big black heading on the left */
  title: string
  /** Small uppercase wide-tracking meta on the right (e.g. "90 tools · ordered by popularity") */
  meta?: string
  /** Additional classes on the outer wrapper */
  className?: string
}

/**
 * IndexSectionHeader — magazine-style section header: heavy black display
 * heading on the left, tiny uppercase tracked meta text on the right,
 * separated from the content below by a hard black rule.
 *
 * Stacks on mobile (title above meta), rolls into a single row at `sm+`.
 * Used above the "The index" grid on `/tools` and any similar list surface.
 */
export function IndexSectionHeader({ title, meta, className = "" }: IndexSectionHeaderProps) {
  return (
    <div
      className={[
        "flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-2 sm:gap-4 mb-6 sm:mb-7 border-b border-gray-900 pb-3 sm:pb-4",
        className,
      ].join(" ")}
    >
      <h2 className="text-2xl sm:text-[28px] font-black tracking-[-0.025em] text-gray-900 m-0">
        {title}
      </h2>
      {meta && (
        <span className="text-[11px] sm:text-xs uppercase tracking-[0.15em] text-gray-500">
          {meta}
        </span>
      )}
    </div>
  )
}
